export const fallbackLng = 'en'
export const defaultLanguage = fallbackLng
export const languages = [fallbackLng, 'en-US', 'en-GB', 'de'] // Support regional variants
export const defaultNS = 'translation'
export const cookieName = 'i18'
export const headerName = 'x-i18-current-language'